import type { ButtonHTMLAttributes, ComponentChildren } from "preact";
import { cx } from "./lib/cx.ts";
import { Icon } from "./Icon.tsx";

/**
 * A step back inside a panel or page, reading as the place it returns to
 * ("Hub summary"). Rule: the label names the destination, never "Back"; use it
 * for in-place navigation, and a Breadcrumb for a page's ancestry.
 */
export function BackButton({ children, class: className, ...rest }: { children: ComponentChildren; class?: string } & Omit<ButtonHTMLAttributes<HTMLButtonElement>, "class" | "children">) {
  return (
    <button type="button" {...rest} class={cx("ui-back", className)}>
      <Icon name="arrow" size={16} class="ui-back__icon" />
      {children}
    </button>
  );
}
